// @flow

const BRANCHES_ADD = "BRANCHES_ADD";
const BRANCHES_FETCH = "BRANCHES_FETCH";
const SET_BRANCH_FILTER = "SET_BRANCH_FILTER";

const BASKET_CREATE = "BASKET_CREATE";
const BASKET_CREATE_START = "BASKET_CREATE_START";
const BASKET_CREATE_DONE = "BASKET_CREATE_DONE";
const BASKET_CREATE_ERROR = "BASKET_CREATE_ERROR";
const BASKET_SHOWED = "BASKET_SHOWED";
const SET_IS_GROUP_ORDER = "SET_IS_GROUP_ORDER";
const SET_GROUP_BASKET = "SET_GROUP_BASKET";
const FETCH_GROUP_BASKET = "FETCH_GROUP_BASKET";

const CONFIG_FETCH = "CONFIG_FETCH";
const CONFIG_SET = "CONFIG_SET";
const CHANGE_FILTER = "CHANGE_FILTER";

const LOCATION_ADD = "LOCATION_ADD";
const SET_PERMISSION = "SET_PERMISSION";
const CONFIRM_DELIVERY_LOCATION = "CONFIRM_DELIVERY_LOCATION";
const HANDLE_SET_DELIVERY_LOCATION = "HANDLE_SET_DELIVERY_LOCATION";
const SET_DELIVERY_AVAILABILITY = "SET_DELIVERY_AVAILABILITY";
const SET_DELIVERY_AVAILABILITY_START = "SET_DELIVERY_AVAILABILITY_START";
const SET_PICKUP_AVAILABILITY = "SET_PICKUP_AVAILABILITY";
const DELIVERY_LOCATION_SET = "DELIVERY_LOCATION_SET";
const FETCH_GPS_LOCATION_START = "FETCH_GPS_LOCATION_START";
const FETCH_GPS_LOCATION_END = "FETCH_GPS_LOCATION_END";
const SET_ORDER_FLOW = "SET_ORDER_FLOW";
const CONFIRM_PICKUP_RESTAURANT = "CONFIRM_PICKUP_RESTAURANT";
const SELECT_PICKUP_RESTAURANT = "SELECT_PICKUP_RESTAURANT";
const SET_MARKER_RESTAURANT = "SET_MARKER_RESTAURANT";
const SELECT_ANOTHER_RESTAURANT = "SELECT_ANOTHER_RESTAURANT";

const ORDERS_ADD = "ORDERS_ADD";
const ORDERS_FETCH = "ORDERS_FETCH";
const ORDER_CANCEL = "ORDER_CANCEL";
const ORDER_CANCEL_DONE = "ORDER_CANCEL_DONE";
const ASYNC_ORDER_COMPLETED = "ASYNC_ORDER_COMPLETED";
const ASYNC_ORDER_FAILED = "ASYNC_ORDER_FAILED";
const START_ASYNC_ORDER_FETCH = "START_ASYNC_ORDER_FETCH";
const ORDER_DRIVER_STATUS_FETCH = "ORDER_DRIVER_STATUS_FETCH";
const ORDER_DRIVER_STATUS_FETCH_ERROR = "ORDER_DRIVER_STATUS_FETCH_ERROR";
const ORDER_DRIVER_STATUS_FETCH_SUCCESS = "ORDER_DRIVER_STATUS_FETCH_SUCCESS";
const INCREMENT_ORDER_CURRENT_PAGE = "INCREMENT_ORDER_CURRENT_PAGE";
const RESET_ORDER_CURRENT_PAGE = "RESET_ORDER_CURRENT_PAGE";
const DO_GEO_FENCE_TRACKING = "DO_GEO_FENCE_TRACKING";

const PRODUCTS_FETCH = "PRODUCTS_FETCH";
const PRODUCTS_FETCH_DONE = "PRODUCTS_FETCH_DONE";
const PRODUCTS_FETCH_START = "PRODUCTS_FETCH_START";

const HERO_ITEMS_FETCH = "HERO_ITEMS_FETCH";
const HERO_ITEMS_FETCH_DONE = "HERO_ITEMS_FETCH_DONE";
const HERO_ITEMS_FETCH_START = "HERO_ITEMS_FETCH_START";
const SET_FILTER_FROM_HERO_SECTION = "SET_FILTER_FROM_HERO_SECTION";
const SET_FILTER_FROM_HERO_SECTION_DONE = "SET_FILTER_FROM_HERO_SECTION_DONE";

const PRODUCT_LIST = "PRODUCT_LIST";
const PRODUCT_LIST_START = "PRODUCT_LIST_START";
const PRODUCT_SET = "PRODUCT_SET";

const MAKE_API_CALL = "MAKE_API_CALL";
const GET_GEO_LOCATION_PERMISSION = "GET_GEO_LOCATION_PERMISSION";

const STARTUP_PROCESS = "STARTUP_PROCESS";
const LOGIN_PROCESS = "LOGIN_PROCESS";
const REGISTER_PROCESS = "REGISTER_PROCESS";
const FORGOT_PASSWORD_PROCESS = "FORGOT_PASSWORD_PROCESS";
const AUTHENTICATE_USER_START = "AUTHENTICATE_USER_START";
const REGISTER_USER_DONE = "REGISTER_USER_DONE";
const REGISTER_USER_ERROR = "REGISTER_USER_ERROR";
const LOGIN_USER_DONE = "LOGIN_USER_DONE";
const LOGIN_USER_ERROR = "LOGIN_USER_ERROR";
const FORGOT_PASSWORD_DONE = "FORGOT_PASSWORD_DONE";
const FORGOT_PASSWORD_ERROR = "FORGOT_PASSWORD_ERROR";
const SIGNOUT = "SIGNOUT";
const UPDATE_USER_PROCESS = "UPDATE_USER_PROCESS";
const UPDATE_USER_START = "UPDATE_USER_START";
const UPDATE_USER_DONE = "UPDATE_USER_DONE";
const UPDATE_USER_ERROR = "UPDATE_USER_ERROR";
const SMS_VERIFICATION = "SMS_VERIFICATION";
const SMS_VERIFICATION_DONE = "SMS_VERIFICATION_DONE";
const SMS_VERIFICATION_ERROR = "SMS_VERIFICATION_ERROR";
const RESET_SMS_VERIFICATION = "RESET_SMS_VERIFICATION";
const RESEND_OTP = "RESEND_OTP";
const RESEND_OTP_ERROR = "RESEND_OTP_ERROR";
const RESEND_OTP_DONE = "RESEND_OTP_DONE";
const CLEAR_OTP_ERRORS = "CLEAR_OTP_ERRORS";
const CLEAR_REGISTER_USER_TOKEN = "CLEAR_REGISTER_USER_TOKEN";
const DO_VERIFICATIONS = "DO_VERIFICATIONS";
const HANDLE_NOTIFICATIONS = "HANDLE_NOTIFICATIONS";

const ORDER_CREATE = "ORDER_CREATE";
const ORDER_CREATE_DONE = "ORDER_CREATE_DONE";
const ORDER_CREATE_START = "ORDER_CREATE_START";
const ASYNC_ORDER = "ASYNC_ORDER";

const ADD_TO_BASKET = "ADD_TO_BASKET";
const EDIT_BASKET = "EDIT_BASKET";
const DELETE_BASKET = "DELETE_BASKET";
const CLEAR_BASKET = "CLEAR_BASKET";
const CLEAR_BASKET_AFTER_ORDER = "CLEAR_BASKET_AFTER_ORDER";
const MARK_ITEMS_UNAVAILABLE = "MARK_ITEMS_UNAVAILABLE";
const MARK_ITEMS_AVAILABLE = "MARK_ITEMS_AVAILABLE";
const VALIDATE_BASKET = "VALIDATE_BASKET";
const EDIT_INDIVIDUAL_OPTIONS = "EDIT_INDIVIDUAL_OPTIONS";
const DELETE_INDIVIDUAL_OPTIONS = "DELETE_INDIVIDUAL_OPTIONS";

const PAYMENT_SESSION_CREATE = "PAYMENT_SESSION_CREATE";
const PAYMENT_SESSION_UPDATE = "PAYMENT_SESSION_UPDATE";
const PAYMENT_SET_ERRORS = "PAYMENT_SET_ERRORS";
const PAYMENT_SET_3DS_DATA = "PAYMENT_SET_3DS_DATA";
const PAYMENT_CANCEL_CHECKOUT = "PAYMENT_CANCEL_CHECKOUT";
const PAYMENT_SET_SESSION_ID = "PAYMENT_SET_SESSION_ID";
const PAYMENT_CHECKOUT_WITH_CARD = "PAYMENT_CHECKOUT_WITH_CARD";
const PAYMENT_CHECKOUT_START = "PAYMENT_CHECKOUT_START";
const PAYMENT_CHECKOUT_DONE = "PAYMENT_CHECKOUT_DONE";
const SAVE_PAYMENT_METHOD = "SAVE_PAYMENT_METHOD";
const ADD_PAYMENT_METHOD = "ADD_PAYMENT_METHOD";
const ADD_PAYMENT_METHOD_ERROR = "ADD_PAYMENT_METHOD_ERROR";
const ADD_PAYMENT_METHOD_DONE = "ADD_PAYMENT_METHOD_DONE";
const LIST_PAYMENT_METHOD = "LIST_PAYMENT_METHOD";
const LIST_PAYMENT_METHOD_ERROR = "LIST_PAYMENT_METHOD_ERROR";
const LIST_PAYMENT_METHOD_DONE = "LIST_PAYMENT_METHOD_DONE";
const DELETE_PAYMENT_METHOD = "DELETE_PAYMENT_METHOD";
const DELETE_PAYMENT_METHOD_DONE = "DELETE_PAYMENT_METHOD_DONE";
const DELETE_PAYMENT_METHOD_ERROR = "DELETE_PAYMENT_METHOD_ERROR";
const CLEAR_ADD_PAYMENT_METHOD_STATE = "CLEAR_ADD_PAYMENT_METHOD_STATE";

const ERROR_SAVE = "ERROR_SAVE";
const CLEAR_ERROR = "CLEAR_ERROR";

const APP_STATE_CHANGE = "APP_STATE_CHANGE";

const INVALID_TOKEN = "INVALID_TOKEN";
const INVALIDATE_SESSION = "INVALIDATE_SESSION";

const UPDATE_FCM_TOKEN = "UPDATE_FCM_TOKEN";

const UPDATE_DEVICE_TOKEN = "UPDATE_DEVICE_TOKEN";

const LOCALE_CHANGE = "LOCALE_CHANGE";

const GET_APP_VERSIONS = "GET_APP_VERSIONS";
const SET_APP_VERSIONS = "SET_APP_VERSIONS";
const SET_SHOULD_UPGRADE = "SET_SHOULD_UPGRADE";

const SET_SMS_OTP_FLOW = "SET_SMS_OTP_FLOW";
const SMS_OTP_FLOW_BACK = "SMS_OTP_FLOW_BACK";

export {
  BRANCHES_ADD,
  BRANCHES_FETCH,
  SET_BRANCH_FILTER,
  CONFIG_FETCH,
  CONFIG_SET,
  CHANGE_FILTER,
  BASKET_CREATE,
  BASKET_CREATE_START,
  BASKET_CREATE_DONE,
  BASKET_CREATE_ERROR,
  MARK_ITEMS_UNAVAILABLE,
  MARK_ITEMS_AVAILABLE,
  LOCATION_ADD,
  SET_PERMISSION,
  CONFIRM_DELIVERY_LOCATION,
  DELIVERY_LOCATION_SET,
  FETCH_GPS_LOCATION_START,
  FETCH_GPS_LOCATION_END,
  SET_ORDER_FLOW,
  CONFIRM_PICKUP_RESTAURANT,
  SELECT_PICKUP_RESTAURANT,
  SET_MARKER_RESTAURANT,
  SELECT_ANOTHER_RESTAURANT,
  HANDLE_SET_DELIVERY_LOCATION,
  SET_DELIVERY_AVAILABILITY,
  SET_DELIVERY_AVAILABILITY_START,
  SET_PICKUP_AVAILABILITY,
  ORDERS_ADD,
  ORDERS_FETCH,
  ORDER_CANCEL,
  ORDER_CANCEL_DONE,
  ASYNC_ORDER_COMPLETED,
  ASYNC_ORDER_FAILED,
  START_ASYNC_ORDER_FETCH,
  PRODUCTS_FETCH,
  PRODUCTS_FETCH_DONE,
  PRODUCTS_FETCH_START,
  HERO_ITEMS_FETCH,
  HERO_ITEMS_FETCH_DONE,
  HERO_ITEMS_FETCH_START,
  SET_FILTER_FROM_HERO_SECTION,
  SET_FILTER_FROM_HERO_SECTION_DONE,
  PRODUCT_LIST,
  PRODUCT_LIST_START,
  PRODUCT_SET,
  ORDER_CREATE,
  ORDER_CREATE_DONE,
  ORDER_CREATE_START,
  ASYNC_ORDER,
  ORDER_DRIVER_STATUS_FETCH,
  ORDER_DRIVER_STATUS_FETCH_ERROR,
  ORDER_DRIVER_STATUS_FETCH_SUCCESS,
  INCREMENT_ORDER_CURRENT_PAGE,
  RESET_ORDER_CURRENT_PAGE,
  DO_GEO_FENCE_TRACKING,
  MAKE_API_CALL,
  GET_GEO_LOCATION_PERMISSION,
  STARTUP_PROCESS,
  LOGIN_PROCESS,
  REGISTER_PROCESS,
  FORGOT_PASSWORD_PROCESS,
  SIGNOUT,
  AUTHENTICATE_USER_START,
  REGISTER_USER_DONE,
  REGISTER_USER_ERROR,
  LOGIN_USER_DONE,
  LOGIN_USER_ERROR,
  FORGOT_PASSWORD_DONE,
  FORGOT_PASSWORD_ERROR,
  SMS_VERIFICATION,
  SMS_VERIFICATION_DONE,
  SMS_VERIFICATION_ERROR,
  RESET_SMS_VERIFICATION,
  RESEND_OTP,
  RESEND_OTP_ERROR,
  RESEND_OTP_DONE,
  CLEAR_OTP_ERRORS,
  CLEAR_REGISTER_USER_TOKEN,
  DO_VERIFICATIONS,
  HANDLE_NOTIFICATIONS,
  ADD_TO_BASKET,
  EDIT_BASKET,
  DELETE_BASKET,
  CLEAR_BASKET,
  CLEAR_BASKET_AFTER_ORDER,
  BASKET_SHOWED,
  SET_IS_GROUP_ORDER,
  SET_GROUP_BASKET,
  FETCH_GROUP_BASKET,
  PAYMENT_CANCEL_CHECKOUT,
  PAYMENT_CHECKOUT_DONE,
  PAYMENT_CHECKOUT_START,
  PAYMENT_CHECKOUT_WITH_CARD,
  PAYMENT_SESSION_CREATE,
  PAYMENT_SESSION_UPDATE,
  PAYMENT_SET_3DS_DATA,
  PAYMENT_SET_ERRORS,
  PAYMENT_SET_SESSION_ID,
  ADD_PAYMENT_METHOD,
  ADD_PAYMENT_METHOD_ERROR,
  ADD_PAYMENT_METHOD_DONE,
  DELETE_PAYMENT_METHOD,
  DELETE_PAYMENT_METHOD_DONE,
  DELETE_PAYMENT_METHOD_ERROR,
  LIST_PAYMENT_METHOD,
  LIST_PAYMENT_METHOD_ERROR,
  LIST_PAYMENT_METHOD_DONE,
  CLEAR_ADD_PAYMENT_METHOD_STATE,
  ERROR_SAVE,
  CLEAR_ERROR,
  UPDATE_USER_PROCESS,
  UPDATE_USER_START,
  UPDATE_USER_ERROR,
  UPDATE_USER_DONE,
  APP_STATE_CHANGE,
  UPDATE_FCM_TOKEN,
  INVALID_TOKEN,
  INVALIDATE_SESSION,
  VALIDATE_BASKET,
  EDIT_INDIVIDUAL_OPTIONS,
  DELETE_INDIVIDUAL_OPTIONS,
  LOCALE_CHANGE,
  UPDATE_DEVICE_TOKEN,
  SAVE_PAYMENT_METHOD,
  GET_APP_VERSIONS,
  SET_APP_VERSIONS,
  SET_SHOULD_UPGRADE,
  SET_SMS_OTP_FLOW,
  SMS_OTP_FLOW_BACK,
};
